import { Component, ElementRef, HostBinding, Input } from '@angular/core';

import { tipAnimation } from './tip.animation';

@Component({
  selector: 'app-tip',
  template: `
    <div class="content" class="{{ class }}" @tooltip>
      <div class="tooltip-title">{{ title }}</div>
      <span [innerHTML]="text"></span>
    </div>
  `,
  styleUrls: ['tip.component.scss'],
  animations: [tipAnimation],
})
export class TipComponent<T> {
  @Input()
  text = '';

  @Input()
  title? = '';

  @Input()
  @HostBinding('class')
  class?: string | false;

  @Input()
  data?: T;

  close = () => {};

  constructor(public elementRef: ElementRef<HTMLElement>) {}
}
